/**
 * 契約タイプ関連のAPIエンドポイント
 */

import apiClient from '../client';
import type { ContractType } from '../../../types';

export const contractTypeApi = {
  /**
   * 契約タイプ一覧取得
   */
  getContractTypes: async (): Promise<ContractType[]> => {
    return apiClient.get<ContractType[]>('/contract-types/');
  },

  /**
   * 契約タイプ詳細取得
   */
  getContractType: async (id: number): Promise<ContractType> => {
    return apiClient.get<ContractType>(`/contract-types/${id}`);
  }
};
